import { Component } from "@angular/core";

import { SvgMixinComponent } from "../svg-mixin.component";

@Component({
  selector: "med-icon-volume-min",
  templateUrl: "./med-icon-volume-min.component.html",
})
export class MedIconVolumeMinComponent extends SvgMixinComponent {}
